import React from "react";
import { Form } from "antd";
import { MainContainer, StyledInput, StyledPasswordInput, StyledLabel } from "./styles";

const InputWithLabel = ({
  label,
  name,
  placeholder,
  width,
  rules,
  type = "text",
  dependencies,
  validateTrigger,
  disabled = false,
}) => {
  return (
    <MainContainer>
      <Form.Item
        label={<StyledLabel>{label}</StyledLabel>}
        name={name}
        rules={rules}
        dependencies={dependencies}
        validateTrigger={validateTrigger}
        style={{ width: width ? width : "25.6rem" }}
      >
        {type === "password" ? (
          <StyledPasswordInput
            size="large"
            placeholder={placeholder}
            visibilityToggle
          />
        ) : (
          <StyledInput
            size="large"
            placeholder={placeholder}
            type={type}
            disabled={disabled}
          />
        )}
      </Form.Item>
    </MainContainer>
  );
};

export default InputWithLabel;
